<template>
  
  <div class="creek-audio-player">
    <div class="creek-header">
    <!--
      <div class="creek-image-container">
        <img v-if="Broadcast.relationships.image" :src="Broadcast.relationships.image.url_sm" /> 
        <img v-if="Broadcast.relationships.show.relationships.image" :src="Broadcast.relationships.image.url_sm" /> 
      </div>
    -->
      <div class="creek-controls">
        <button class="creek-button-main" type="button">
          <div v-if="status=='ready'" class="creek-button-play"></div>
          <div v-if="status=='playing'" class="creek-button-pause"></div>
          <div v-if="status=='loading'" class="creek-button-loading"></div>
          <div v-if="status=='error'" class="creek-button-error"></div>
        </button>
      </div>
      <div class="creek-seek-bar">
        <div class="creek-duration"></div>
        <div class="creek-position"></div>
      </div>
    </div>
    <div class="creek-playlist">
      <div class="creek-track" v-for="Track in Broadcast.relationships.playlist" v-index="Track.id">
        <span v-if="Track.starts" class="creek-track-time"></span>
        <span v-if="Track.artist" v-html="Track.artist" class="creek-track-artist"></span>
        <span v-if="Track.artist && Track.title" class="creek-track-divide1"> - </span>
        <span v-if="Track.title" v-html="Track.title" class="creek-track-title"></span>
        <span v-if="Track.label" class="creek-track-divide1">(</span><span v-if="Track.label" v-html="Track.label" class="creek-track-label"></span><span v-if="Track.label" class="creek-track-divide1">)</span>
      </div>
    </div>
    <div class="creek-footer">
      <a href="#"><img src="https://cdn.creek.fm/res/audio-player/logo.png" /></a>
    </div>
  </div>

</template>

<style lang="stylus" scoped>

  .creek-audio-player
    
    display block
    position relative

    /*background #eed*/
    
    background #fff
    box-shadow 0 4px 6px rgba(0,0,0,.1);
    border-radius 5px
    overflow hidden

    .creek-image-container
      
      max-width 200px

      img
        height auto
        max-width 100%

</style>

<script type="text/javascript">

import JSONP from 'jsonp';

export default {
  name: 'creek-audio-player',
  props: ['broadcast-id'],
  data: function(){
    return {
      Broadcast: {
        title: '',
        relations: {
          playlist: [],
          image: {},
          audio: []
        }
      },
      status: null
    }
  },
  methods: {
    play: function(url) {
      Creek.audio.play(url, true);
    },
    pause: function(url) {
      Creek.audio.play(url, true);
    },
  },
  created: function () {

      var URL = this.Creek.config.content.baseURLForAPI 
        + "/api/v2/broadcasts/" 
        + this.$route.params.broadcastID

      var _this = this;

      JSONP(URL, null, function(err, data) {
        console.log(data.data);
        _this.Broadcast = data.data;
        // _this.Creek.util.setTitle(_this.Broadcast.attributes.title);
        // _this.swapPageClass("broadcast");
      })
    
    return true;

  }
}
</script>
